module.exports = __webpack_public_path__ + "static/media/materials-b.fe008024.svg";